import { Injectable } from '@angular/core';
import { HttpDataService } from '../_service/http-data.service';
import { of, throwError, Observable, EMPTY } from 'rxjs';
import { CacheStorageModel } from '../_models/cache-storage-model';
import { shareReplay, catchError, tap } from 'rxjs/operators';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CacheService {
  val: string = "";
  cacheObj: any;
  cacheList: Map<string, CacheStorageModel<any>> = new Map();
  appDetails: any = {};
  appurl: string = "";
  observable: any;
  title = environment.title; // envirionment
  apiURL = environment.apiURL; //envirionment
  constructor(private httpDataService: HttpDataService) {
    if (sessionStorage.hasOwnProperty('appconfig')) {
      this.appDetails = JSON.parse(sessionStorage.getItem('appconfig') || '{}');
      this.appurl = this.appDetails['protocol'] + "://" + this.appDetails['host'] + ":" + this.appDetails['port'];
    }
  }
  clearCache() {
    this.cacheList.clear();
  }

  getServiceData<T>(serviceId: string, serviceDets: any, requestpayload = {}, params?: {}): Observable<T[]> {
    var cacheFlag = serviceDets['cacheRequire'];
    //app_api check
    if (serviceDets.hasOwnProperty('appAPI')) {
      if (serviceDets['appAPI']) {

        this.appurl = this.appDetails['app_protocol'] + "://" + this.appDetails['app_host'];
       
        if (this.appDetails['app_port']) {
          this.appurl += ":" + this.appDetails['app_port'];
        }
      }
      else {
        this.appurl = this.appDetails['protocol'] + "://" + this.appDetails['host'];
        if (this.appDetails['port']) {
          this.appurl += ":" + this.appDetails['port'];
        }
              }
    }
    else {
      this.appurl = this.appDetails['protocol'] + "://" + this.appDetails['host'];
      if (this.appDetails['port']) {
        this.appurl += ":" + this.appDetails['port'];
      }
    }
 
    //get cacheItem
    if (this.getCacheItem(serviceId) && cacheFlag) {
            return this.getCacheItem(serviceId);
    }
    if (Object.keys(this.appDetails).length === 0 && this.appDetails.constructor === Object)
      return throwError("App Configuration Not Found!");
    if (serviceDets['method'].toLowerCase() == "post") {
      this.observable = this.httpDataService.getBackendDatausehttppost<T[]>(requestpayload, this.appurl + "/" + serviceDets['apiName']);
    } else if (serviceDets['method'].toLowerCase() == "get") {
      this.observable = this.httpDataService.getBackendDatausehttpgetparams<T[]>(this.appurl + "/" + serviceDets['apiName'].replace('appname', this.title), requestpayload)
    } else if (serviceDets['method'].toLowerCase() == "put") {
      this.observable = this.httpDataService.getBackendDatausehttpput<T[]>(requestpayload, this.appurl + "/" + serviceDets['apiName'])
    }
    else if (serviceDets['method'].toLowerCase() == "postwithparams") {
      this.observable = this.httpDataService.getBackendDatausehttppostparams<T[]>(requestpayload, this.appurl + "/" + serviceDets['apiName'], params)
   
    }
    if (cacheFlag) {
      this.observable.pipe(
        catchError(err => {
          //delete cacheItem
          this.deleteCacheItem(serviceId);
          return EMPTY;
        }))
      //set cacheItem
      this.setCacheItem(serviceId, this.observable, this.appDetails['cacheExpTime']);
    }
    return this.observable;
  }

  getCacheItem(serviceId: string) {
    if (!this.cacheList.has(serviceId)) {
      return null;
    }
    let cacheData = this.cacheList.get(serviceId);
    //sessionStoarge
    let expTime = (cacheData['expires'] == undefined) ? 0 : cacheData['expires'];
    // delete the cache item if it has expired
    if (expTime <= Date.now()) {
      this.deleteCacheItem(serviceId);
      return null;
    }
    return cacheData?.observable;
  }


  setCacheItem(serviceId: string, observable: Observable<any>, expTime: number): void {
    const EXPIRES = Date.now() + expTime;
    this.cacheList.set(serviceId, new CacheStorageModel(EXPIRES, observable));
  }

  deleteCacheItem(serviceId: string): void {
    if (this.cacheList.has(serviceId))
      this.cacheList.delete(serviceId)
  }


}
